// 导入axios接口
import axiosRequest from '@/utils/axios-default-request';

//  使用旧密码修改密码
let getIsPassword = (data)=> axiosRequest.postBody('/supinterface/getIsPassword',data)

//  使用旧密码修改密码
let xqgetIsPassword = (data)=> axiosRequest.postBody('/supinterface/xqgetIsPassword',data)

//  使用旧密码修改密码
let upPassword = (data)=> axiosRequest.postBody('/supinterface/upPassword',data)

//  使用旧密码修改密码
let addPassword = (data)=> axiosRequest.postBody('/supinterface/addPassword',data)

//  使用验证码修改密码 --- 获取验证码
let resetPassActiveCode = (data)=> axiosRequest.postBody('/supinterface/resetPassActiveCode',data)

//  使用验证码修改密码 --- 提交表单
let resetPassword = (data)=> axiosRequest.postBody('/supinterface/resetPassword',data)

// 绑定邮箱 -- 获取验证码  params:   supLoginName  邮箱
let bindMailboxActiveCode = (data)=> axiosRequest.postBody('/supinterface/bindMailboxActiveCode',data)

//  绑定邮箱 --- 提交表单 
/***
 * @params supUserId 供应商用户id,supEmail 换绑的邮箱, supYzm 验证码
 * */
let upSupEmail = (data)=> axiosRequest.postBody('/supinterface/upSupEmail',data)

// 绑定手机号 -- 获取验证码  params:   supLoginName  手机号
let bindMobilePhoneActiveCode = (data)=> axiosRequest.postBody('/supinterface/bindMobilePhoneActiveCode',data)

//  绑定邮箱 --- 提交表单 
/***
 * @params supUserId 供应商用户id,   supPhone 换绑的手机号,  supYzm 验证码
 * */
let upSupPhone = (data)=> axiosRequest.postBody('/supinterface/upSupPhone',data)

/** 客户端 */
//  使用旧密码修改密码
let xqupPassword = (data)=> axiosRequest.postBody('/supinterface/upPassword',data)

//  使用验证码修改密码 --- 获取验证码
let xqresetPassActiveCode = (data)=> axiosRequest.postBody('/supinterface/resetPassActiveCode',data)

//  使用验证码修改密码 --- 提交表单
let xqresetPassword = (data)=> axiosRequest.postBody('/supinterface/resetPassword',data)

// 绑定邮箱 -- 获取验证码  params:   supLoginName  邮箱
let xqbindMailboxActiveCode = (data)=> axiosRequest.postBody('/supinterface/bindMailboxActiveCode',data)

//  绑定邮箱 --- 提交表单 
/***
 * @params supUserId 供应商用户id,supEmail 换绑的邮箱, supYzm 验证码
 * */
let xqupSupEmail = (data)=> axiosRequest.postBody('/supinterface/upSupEmail',data)

// 绑定手机号 -- 获取验证码  params:   supLoginName  手机号
let xqbindMobilePhoneActiveCode = (data)=> axiosRequest.postBody('/supinterface/bindMobilePhoneActiveCode',data)

//  绑定手机号 --- 提交表单 
/***
 * @params supUserId 供应商用户id,   supPhone 换绑的手机号,  supYzm 验证码
 * */
let xqupSupPhone = (data)=> axiosRequest.postBody('/supinterface/upSupPhone',data)

// 获取通知设置
let getSysBusinessPush = (data)=>axiosRequest.postBody('/supinterface/getSysBusinessPush',data)

// 更改通知设置
let getUpSysBusinessPush = (data)=>axiosRequest.postBodyJson('/supinterface/getUpSysBusinessPush',data)


export default{
    /** 修改密码 */
    xqgetIsPassword,//客户端查询是否有密码
    getIsPassword,//查询是否有密码
    upPassword,// 旧密码修改密码
    addPassword,// 无密码，新增密码
    xqupPassword,//客户端
    resetPassActiveCode,//验证码修改密码 --- 获取验证码
    xqresetPassActiveCode,//客户端
    resetPassword,//验证码修改密码 --- 提交表单
    xqresetPassword,//客户端
    /** 修改绑定邮箱 */
    bindMailboxActiveCode,//绑定邮箱 -- 获取验证码
    upSupEmail,//绑定邮箱----提交表单
    /** 修改绑定手机号 */
    bindMobilePhoneActiveCode,//绑定手机号 --- 获取验证码
    upSupPhone,//绑定手机号 --- 提交表单

    /** 客户端修改绑定 */
    xqbindMailboxActiveCode,//绑定邮箱 -- 获取验证码
    xqupSupEmail,//绑定邮箱----提交表单
    /** 修改绑定手机号 */
    xqbindMobilePhoneActiveCode,//绑定手机号 --- 获取验证码
    xqupSupPhone,//绑定手机号 --- 提交表单
    getSysBusinessPush,
    getUpSysBusinessPush
}